import SwimlanePreview from './SwimlanePreview';

export default SwimlanePreview;
